import React from "react"
// CSS
import { Modal } from "@sogei/react-web-components-catalog"

function ModalMob(props: any) {
    let mob = props.mob
    return (
        <Modal
            labelId="label"
            containerId="modal-1"
            title={mob !== undefined ? mob.nome : ""}
            body={mob !== undefined ? mob.descrizione : ""}
        ></Modal>
    )
}
export default ModalMob
